module.exports = __webpack_public_path__ + "img/policy-3.926546ad.png";